























import {Component, Prop, Vue} from 'vue-property-decorator';
import {i18nMixin} from '@/modules/neodash/mixins';
import TableHeadGoalSetting from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/table-head-goal-setting.component.vue';
import TableBodyGoalSetting from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/table-body-goal-setting.component.vue';
import TitleTableGoalSetting from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/title-table-goal-setting.component.vue';
import {GoalSettingColumns} from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/GoalSettingColumns';
import {EconomicGroup, Families} from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/types';
import TableFooterGoalSetting from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/table-footer-goal-setting.component.vue';
import TableViewBodyGoalSettingComponent from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/table-view-body-goal-setting.component.vue';
import TableViewFooterGoalSettingComponent from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/table-view-footer-goal-setting.component.vue';

@Component({
  name: 'TableComponent',
  components: {
    TitleTableGoalSetting,
    TableHeadGoalSetting,
    TableBodyGoalSetting,
    TableFooterGoalSetting,
    TableViewBodyGoalSettingComponent,
    TableViewFooterGoalSettingComponent,
  },
})
export default class TableGoalSettingComponent extends Vue {
  public readonly t = i18nMixin.methods.i18n;

  @Prop({required: true})
  public columns: GoalSettingColumns;

  @Prop({required: true})
  public economicGroup: EconomicGroup;

  @Prop({required: true})
  public families: Families;

  @Prop({required: true})
  public needArbitratedGoalJustification: boolean;

  @Prop({required: true})
  public showMonthlyValues: boolean;
}
